import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import isEmpty from 'lodash/isEmpty'
import Img from 'gatsby-image'
import Video from './Video'
import { ReactComponent as PlayIcon } from '../svg/play.svg'

const PlayList = css({
  backgroundColor: '#f5f5f5',
  listStyle: 'none',
  margin: 0,
  maxHeight: '40vh',
  overflow: 'auto',
  padding: 30,
})

const VideoItem = styled('li')(({ active }) => ({
  backgroundColor: '#fff',
  boxShadow: '0 5px 15px rgba(0, 0, 0, .05), 0 0 20px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  display: 'flex',
  marginBottom: 10,
  opacity: active ? 1 : .7,

  '&:hover': { opacity: 1 },
  '&:last-child': { margin: 0 },
}))

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { currentVideo: 0 }
  }

  render() {
    return (
      <div>
        <Video
          url={this.props.videos[this.state.currentVideo].embed.url}
          ratio={this.props.videos[this.state.currentVideo].embed.width / this.props.videos[this.state.currentVideo].embed.height}
        />
        {this.props.videos.length > 1 && <ol className={PlayList}>
          {this.props.videos.map((video, key) => (
            <VideoItem
              key={key}
              onClick={() => this.setState({ currentVideo: key })}
              active={this.state.currentVideo === key}
            >
              <div
                css={{
                  position: 'relative',

                  '&::before': {
                    backgroundColor: 'rgba(0, 0, 0, .15)',
                    content: '""',
                    display: 'block',
                    height: '100%',
                    left: 0,
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    zIndex: 1,
                  }
                }}
              >
                <div
                  css={{
                    height: 60,
                    overflow: 'hidden',
                    width: 60,
                  }}
                >
                  <Img sizes={video.embed.thumbnail.childImageSharp.square} />
                </div>
                <PlayIcon
                  css={{
                    fill: '#fff',
                    height: '2em',
                    left: '50%',
                    position: 'absolute',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '2em',
                    zIndex: 2,
                  }}
                />
              </div>
              <h3
                css={{
                  alignItems: 'center',
                  display: 'flex',
                  fontSize: '.9em',
                  margin: 0,
                  padding: '0 10px',
                }}
              >
                <span>{video.embed.title}</span>
              </h3>
            </VideoItem>
          ))}
        </ol>}
      </div>
    )
  }
}

export default VideoPlayer


// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js